export default {
  name: 'tabChange',
  props: ['tabArr', 'showTab'],
  data() {
    return {
      showTabType: this.showTab || ''
    };
  },

  watch: {
    showTab() {
      this.showTabType = this.showTab;
    }
  },

  methods: {
    changeShowTab(tab) {
      this.showTabType = tab;
      this.$emit('changeTab', tab);
      return tab;
    }
  }
};
